import React from 'react';
import BridleImage from '../components/BridleImage';
import ProductReview from '../components/ProductReview';
import ReviewActions from '../components/ReviewActions';
import Subtotal from '../components/Subtotal';
import Toolbar from '../components/Toolbar';

const Review = () => {
    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Review" />
            <div className="review-title">Your Custom Bridle Preview</div>
            <BridleImage />
            <Subtotal />
            <ProductReview />
            <ReviewActions />
        </div>
    );
};

export default Review;
